import { create } from 'zustand';

interface UiState {
  palette: boolean;
  set: (patch: Partial<Omit<UiState, 'set'>>) => void;
}

export const useUi = create<UiState>()((set) => ({
  palette: false,
  set: (patch) => set(patch),
}));

export const openPalette = () => useUi.getState().set({ palette: true });
